import clsx from "clsx";
import Autocomplete from "ui/common/components/input/Autocomplete/Autocomplete";
import { useDebounce } from "@commonlibs";
import { useEffect, useRef, useState } from "react";
import useGetGiftCardCategories from "features/giftcards/hooks/useGetGiftCardCategories";
import { GiftCardCategoriesAutocompleteProps } from "./GiftCardCategoriesAutocomplete.types";

export default function GiftCardCategoriesAutocomplete({
    className,
    defaultSearch,
    onSearchChange,
    onChange,
    ...rest
}: GiftCardCategoriesAutocompleteProps): JSX.Element {
    const [search, setSearch] = useState("");
    const { value, handleChange, debouncing } = useDebounce<string>(defaultSearch || "", { callback: setSearch });

    const isFirstRender = useRef(true);

    const { data = [], isFetching } = useGetGiftCardCategories({
        query: search,
    });

    const options = data.map((item) => ({
        value: item,
        label: item,
    }));

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return; 
        }
        if (onSearchChange && search !== defaultSearch) {
            onSearchChange(search);
        }
    }, [search]);

    return (
        <Autocomplete
            className={clsx("giftcard-categories-select", className)}
            expandable
            isLoading={isFetching || debouncing}
            onSearchChange={handleChange}
            search={value}
            options={options}
            onChange={onChange}
            {...rest}
        />
    );
}
